@if (visibleWindows().length) {
  <!-- Floats over the page rather than pushing it down. The container ignores clicks so only the
       banners themselves block what's underneath. -->
  <div
    class="pointer-events-none fixed inset-x-0 top-0 z-50 flex flex-col items-center gap-2 px-4 pt-4 sm:px-6 lg:px-8"
  >
    @for (window of visibleWindows(); track window.id) {
      <joii-notification
        type="warning"
        class="pointer-events-auto block w-full max-w-3xl rounded-lg shadow-lg"
        data-automationid="maintenance-window-banner"
      >
        <joii-notification-simple
          [text]="
            window.title +
            ': ' +
            window.message +
            ' Scheduled for ' +
            (window.blockStartsAt | date: 'medium') +
            (window.expectedBlockEndsAt ? ', expected to end ' + (window.expectedBlockEndsAt | date: 'medium') : '') +
            '.'
          "
          (closeClick)="dismiss(window.id)"
        />
      </joii-notification>
    }
  </div>
}
